import React, { useState } from "react";
import { Button, Modal } from "legion-ui";

const ModalExample4 = () => {
  const [isActiveModal3, setIsActiveModal3] = useState(false);

  const modalFooter3 = () => {
    return (
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button onClick={toggleCustomModal3} css={{ marginRight: "12px" }}>
          Go ahead
        </Button>
      </div>
    );
  };
  const toggleCustomModal3 = () => setIsActiveModal3(!isActiveModal3);
  const closeModal3 = () => {
    if (isActiveModal3) {
      toggleCustomModal3();
    }
  };

  return (
    <>
      <Button onClick={toggleCustomModal3} css={{ marginBottom: "12px" }}>
        Modal with custom width and height
      </Button>
      <Modal
        isActive={isActiveModal3}
        modalId="legion-modal-3"
        iconName="File"
        title="Custom Modal Width and Height"
        footer={modalFooter3()}
        onClose={closeModal3}
        width="30%"
        height="300px"
      >
        This is an example to custom modal width and modal height.
        <p>
          You can pass the width and height by percent(%) or pixel(px) unit as
          you need.
        </p>
      </Modal>
    </>
  );
};

export default ModalExample4;
